//para las actividades ya creadas
import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { getActivityTypes } from "../api";

const ActivityList2 = ({ id_c, value, onSelect, includeEmpty = true }) => {
  const { t } = useContext(LanguageContext);
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const run = async () => {
      try {
        if (!id_c) return;
        const data = await getActivityTypes(id_c); // { types: [{id, id_activity}], total }
        if (!alive) return;
        setTypes(data?.types || []);
      } catch (e) {
        console.error("❌ Error loading activity types:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };
    run();
    return () => { alive = false; };
  }, [id_c]);

  if (loading) {
    return <select className="input1" disabled><option>{t("loading") || "Cargando..."}</option></select>;
  }

  return (
    <select
      className="input1"
      value={value || ""}
      onChange={(e) => onSelect && onSelect(e.target.value)}
      required
    >
      {includeEmpty && <option value="">{t("select") || "Seleccione..."}</option>}
      {types.map((tItem) => (
        <option key={tItem.id} value={tItem.id_activity}>
          {tItem.id_activity}
        </option>
      ))}
    </select>
  );
};

export default ActivityList2;


